import { Button } from '@/ui-kit';
import styles from './button-submit-step.module.scss';
import clsx from 'clsx';
import { callYaMetrika } from '@/utils/call-ya-metrika';
import i18n from '@/i18n';

interface Props {
    isLoading?: boolean;
    stepNumber: number;
    href?: string;
    isDisabled?: boolean;
    isGray?: boolean;
    title?: string;
    onClick?: () => void;
}

export const ButtonSubmitStep: React.FC<Props> = ({
    stepNumber = 1,
    isLoading,
    href,
    isDisabled,
    isGray,
    title = i18n.t('registration.next'),
    onClick,
}) => {

    return (
        <Button
            type="submit"
            variant="stretched"
            typeColor="orange"
            isLoading={isLoading}
            isDisabled={isDisabled}
            isLink={!!href}
            to={href}
            onClick={() => onClick?.()}>
            {title}
        </Button>
    );
};
